"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportQueryDialog = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const core_ui_1 = require("@sierralabs/core-ui");
const entity_ui_1 = require("@sierralabs/entity-ui");
const useCreateQuery_1 = require("../hooks/useCreateQuery");
const StyledAlert = (0, styled_components_1.default)(lab_1.Alert) `
  .content:not(:last-child) {
    margin-bottom: 8px;
  }
  .entity-list {
    padding-left: 28px;
  }
  .MuiAlertTitle-root {
    font-size: 15px;
    font-weight: 600;
  }
`;
function useMissingQueryAliases(query) {
    var _a, _b;
    const { entities = [] } = (0, entity_ui_1.useEntityContext)();
    if (!query) {
        return [];
    }
    const mainAlias = (_a = query.config) === null || _a === void 0 ? void 0 : _a.mainAlias;
    const fromTableName = mainAlias === null || mainAlias === void 0 ? void 0 : mainAlias.tablePath;
    const fromEntity = fromTableName
        ? entities.find(e => e.tableName === fromTableName)
        : undefined;
    const notExistingJoin = (((_b = query === null || query === void 0 ? void 0 : query.config) === null || _b === void 0 ? void 0 : _b.joinAttributes) || []).filter(join => !entities.some(entity => entity.tableName === join.alias.tablePath));
    const missingAliases = notExistingJoin.map(join => ({
        alias: join.alias,
        direction: join.direction
    }));
    if (mainAlias && !fromEntity) {
        missingAliases.unshift({ alias: mainAlias });
    }
    return missingAliases;
}
function renderAlias(queryAlias) {
    const { alias, direction } = queryAlias;
    const { name, tablePath } = alias;
    const type = (direction ? `${direction} ` : '')
        .concat(alias.type)
        .toUpperCase();
    const label = name === tablePath ? name : `${name} (${tablePath})`;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("strong", null, type),
        ": ",
        label));
}
const ImportQueryDialog = props => {
    const { open, queryGroupId, onCancel, onImport } = props;
    const onImportRef = (0, react_1.useRef)(onImport);
    const fileInputRef = (0, react_1.useRef)(null);
    const [errorMessage, setErrorMessage] = (0, react_1.useState)('');
    const [importQuery, setImportQuery] = (0, react_1.useState)();
    const { createdQuery, isCreating, error, createQuery } = (0, useCreateQuery_1.useCreateQuery)();
    const missingAliases = useMissingQueryAliases(importQuery);
    const onClose = () => {
        if (!isCreating) {
            onCancel === null || onCancel === void 0 ? void 0 : onCancel();
        }
    };
    const handleFiles = (files) => __awaiter(void 0, void 0, void 0, function* () {
        if (!files || files.length === 0) {
            return;
        }
        const result = yield (0, core_ui_1.readTextFile)(files[0], value => {
            const query = JSON.parse(value || '');
            return query;
        });
        if (result) {
            const { value, error = '' } = result;
            setImportQuery(value);
            setErrorMessage(error);
        }
    });
    const handleSubmit = () => {
        if (!(importQuery === null || importQuery === void 0 ? void 0 : importQuery.name) || isCreating) {
            return;
        }
        const query = Object.assign(Object.assign({}, importQuery), { queryGroupId });
        createQuery(query);
    };
    (0, react_1.useEffect)(() => {
        onImportRef.current = onImport;
    }, [onImport]);
    // reset values
    (0, react_1.useEffect)(() => {
        if (!open) {
            setImportQuery(undefined);
            setErrorMessage('');
        }
    }, [open]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (createdQuery) {
            (_a = onImportRef.current) === null || _a === void 0 ? void 0 : _a.call(onImportRef, createdQuery);
        }
    }, [createdQuery]);
    (0, react_1.useEffect)(() => {
        if (error) {
            setErrorMessage(error.message);
        }
    }, [error]);
    return (react_1.default.createElement(core_1.Dialog, { fullWidth: true, open: open, onClose: onClose },
        isCreating && react_1.default.createElement(core_1.LinearProgress, null),
        react_1.default.createElement(core_1.DialogTitle, null, "Import Query"),
        react_1.default.createElement(core_1.DialogContent, null,
            react_1.default.createElement(core_ui_1.DragArea, { disabled: isCreating, dragLabel: 'Drag exported Query JSON file to import', buttonLabel: 'Select Import File', onClick: () => { var _a; return (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, onUpload: handleFiles }),
            importQuery && (react_1.default.createElement(core_1.Box, { mt: 2 },
                react_1.default.createElement(ImportQueryForm, { value: importQuery, disabled: isCreating, onSubmit: handleSubmit, onChange: dto => setImportQuery(Object.assign(Object.assign({}, importQuery), dto)) }))),
            react_1.default.createElement(core_1.Collapse, { in: missingAliases.length > 0, style: { minHeight: 'unset' } },
                react_1.default.createElement(core_1.Box, { mt: 2 },
                    react_1.default.createElement(StyledAlert, { severity: 'warning' },
                        react_1.default.createElement(lab_1.AlertTitle, null, "Missing Entity References"),
                        react_1.default.createElement(core_1.Typography, { variant: 'body2', className: 'content' },
                            "The imported ",
                            react_1.default.createElement("strong", null, "Query"),
                            " has",
                            ' ',
                            react_1.default.createElement("strong", null, missingAliases.length),
                            " missing",
                            ' ',
                            react_1.default.createElement("strong", null, "Entity"),
                            " reference",
                            missingAliases.length !== 1 && 's',
                            ":"),
                        react_1.default.createElement("ul", { className: 'entity-list' }, missingAliases.map((queryAlias, index) => (react_1.default.createElement("li", { key: `${queryAlias.alias.tablePath}-${index}` },
                            react_1.default.createElement(core_1.Typography, { variant: 'body2' }, renderAlias(queryAlias)))))),
                        react_1.default.createElement(core_1.Typography, { variant: 'body2', className: 'content' }, "You may need to update the Query after importing to fix the references.")))),
            react_1.default.createElement(core_1.Collapse, { in: !!errorMessage, style: { minHeight: 'unset' } },
                react_1.default.createElement(core_1.Box, { mt: 2 },
                    react_1.default.createElement(lab_1.Alert, { severity: 'error' }, errorMessage || 'An error occurred.'))),
            react_1.default.createElement("input", { hidden: true, type: 'file', accept: 'application/json', ref: fileInputRef, onChange: event => {
                    handleFiles(event.target.files);
                    // clear input field
                    if (fileInputRef.current) {
                        fileInputRef.current.value = '';
                    }
                } })),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(core_1.Button, { disabled: isCreating, onClick: onClose }, "Cancel"),
            react_1.default.createElement(core_1.Button, { color: 'secondary', variant: 'contained', disabled: !(importQuery === null || importQuery === void 0 ? void 0 : importQuery.name) || isCreating, onClick: () => handleSubmit() }, "Import Query"))));
};
exports.ImportQueryDialog = ImportQueryDialog;
exports.default = exports.ImportQueryDialog;
const ImportQueryForm = props => {
    var _a, _b;
    const { value, disabled, onSubmit, onChange } = props;
    const { entities } = (0, entity_ui_1.useEntityContext)();
    const selects = ((_a = value.config) === null || _a === void 0 ? void 0 : _a.selects) || [];
    const mainAlias = (_b = value === null || value === void 0 ? void 0 : value.config) === null || _b === void 0 ? void 0 : _b.mainAlias;
    const fromEntity = (mainAlias === null || mainAlias === void 0 ? void 0 : mainAlias.tablePath)
        ? entities === null || entities === void 0 ? void 0 : entities.find(e => e.tableName === (mainAlias === null || mainAlias === void 0 ? void 0 : mainAlias.tablePath))
        : undefined;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_ui_1.ConfigFieldControl, null,
            react_1.default.createElement(core_1.TextField, { autoFocus: true, fullWidth: true, size: 'small', variant: 'outlined', label: 'Query Name', disabled: disabled, error: !value.name, value: value.name || '', onKeyPress: event => {
                    if (event.key === 'Enter') {
                        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
                    }
                }, onChange: event => onChange({ name: event.target.value }) })),
        selects.length > 0 && (react_1.default.createElement(core_1.Box, { mt: 2, mb: 1 },
            react_1.default.createElement("strong", null, "SELECT"),
            ":")),
        selects.length > 0 && (react_1.default.createElement(core_1.Grid, { container: true, spacing: 1 }, selects.map((select, index) => (react_1.default.createElement(core_1.Grid, { item: true, xs: 12, md: 3, key: `${select.selection}-${index}` },
            react_1.default.createElement(core_1.ListItemText, { primary: select.selection, secondary: select.aliasName, primaryTypographyProps: { variant: 'body2' } })))))),
        react_1.default.createElement(core_1.Box, { mt: 2, mb: 1 },
            react_1.default.createElement("strong", null, "FROM"),
            ": ",
            (fromEntity === null || fromEntity === void 0 ? void 0 : fromEntity.name) || '?')));
};
//# sourceMappingURL=ImportQueryDialog.js.map